import {useEffect, useRef} from 'react';
import {PayjpCheckoutError, PayjpCheckoutResponse} from 'react-app-env';

type PayjpCheckoutProps = {
  text: string;
  submitText: string;
  namePlaceholder?: string;
  onCreated?: (token: string) => void;
  onFailed?: (statusCode: number, message: string) => void;
};

export default function PayjpCheckout({
  text,
  submitText,
  namePlaceholder,
  onCreated,
  onFailed,
}: PayjpCheckoutProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    element.innerHTML = '';

    window.payjpCheckoutOnCreated = onCreated
      ? (response: PayjpCheckoutResponse) => onCreated(response.id)
      : null;
    window.payjpCheckoutOnFailed = onFailed
      ? (statusCode: number, response: PayjpCheckoutError) =>
          onFailed(statusCode, response.message)
      : null;

    const script = document.createElement('script');
    script.src = 'https://checkout.pay.jp/';
    // script.classList.add('payjp-button');
    script.classList.add('payjp-button', 'my-payjp-button');
    script.dataset.key = window._env_.REACT_APP_PAYJP_PUBLIC_KEY;
    script.dataset.partial = 'true';
    script.dataset.text = text;
    script.dataset.submitText = submitText;
    if (namePlaceholder) script.dataset.namePlaceholder = namePlaceholder;
    script.dataset.threeDSecure = 'true';
    script.dataset.threeDSecureWorkflow = 'iframe';
    script.dataset.onCreated = 'payjpCheckoutOnCreated';
    script.dataset.onFailed = 'payjpCheckoutOnFailed';

    element.appendChild(script);

    return () => {
      element.innerHTML = '';
      window.payjpCheckoutOnCreated = null;
      window.payjpCheckoutOnFailed = null;
      window.PayjpCheckout = null;
    };
  }, [text, submitText, namePlaceholder, onCreated, onFailed]);

  return <div id="payjp-checkout" ref={containerRef} />;
}
